import { Holder, formatarOab } from '../../utils/holders';

interface CertificateHolderSelectProps {
  id: string;
  /** id do titular; vazio = "Sem titular" */
  value: string;
  onChange: (holderId: string) => void;
  holders: Holder[];
  /**
   * Titular atual do certificado que não está mais entre os ativos (arquivado): aparece como
   * opção para o seletor não mostrar outro nome no lugar dele.
   */
  titularAtual?: { id: string; nome: string } | null;
}

/**
 * D23: "Titular (opcional)" do certificado, igual ao do formulário de credencial.
 * Sem titulares cadastrados, continua visível com a opção "Sem titular".
 */
export function CertificateHolderSelect({ id, value, onChange, holders, titularAtual = null }: CertificateHolderSelectProps) {
  const mostrarAtual = !!titularAtual && !holders.some((holder) => holder.id === titularAtual.id);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-2)' }}>
      <label htmlFor={id} style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-secondary)' }}>Titular (opcional)</label>
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{ width: '100%', minWidth: 0, background: 'var(--color-bg-root)', border: '1px solid var(--color-border-default)', padding: 'var(--space-3)', borderRadius: 'var(--radius-md)', color: 'var(--color-text-primary)' }}
      >
        <option value="">Sem titular</option>
        {mostrarAtual && titularAtual && <option value={titularAtual.id}>{titularAtual.nome}</option>}
        {holders.map((holder) => (
          <option key={holder.id} value={holder.id}>
            {[holder.name, formatarOab(holder)].filter(Boolean).join(' · ')}
          </option>
        ))}
      </select>
    </div>
  );
}
